module.exports = __webpack_public_path__ + "static/media/catalog-3.fbeca4f1.png";